import {AuthRequest} from "../AuthRequest/AuthRequest";

export class BuscarSolicitudRequest extends AuthRequest {

  tipoSolicitud: string;
  identificacion: {
    tipo: string,
    numero: string
  };
  idSolicitud: string;

  constructor(
    tramiteTipo: string,
    tramiteNumero: string,
    identificacionTipo: string,
    identificacionNumero: string,
    tokenRecaptcha: string
  ) {
    super(tokenRecaptcha);
    this.tipoSolicitud = tramiteTipo;
    this.idSolicitud = tramiteNumero;
    this.identificacion = {
      tipo: identificacionTipo,
      numero: identificacionNumero
    };
  }
}
